export default {
  vipUpgrade: {
    title: 'Binabati kita!!',
    message: 'Na-promote ka mula VIP{from} papuntang VIP{to}',
    subtitle: 'Salamat sa iyong suporta. Ang bagong level ay may\neksklusibong serbisyo at espesyal na pribilehiyo.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
